<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FBkzzh/tc-custom/9781459235113.jpg?1741131129461" alt="This image is the cover for the book His Unsuitable Viscountess"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">His Unsuitable Viscountess
      </h1>
      <p class="bookDescription body article font2">
        <p>A lifetime of living in a man's world has given sword-making-factory owner Eleanor Blackwell some very definite opinionsparticularly about the duplicity  of men!<br/><br/>Benjamin Grayson, Viscount Whittonstall, seems  to be cut from a different clothEleanor responds to his touch with a passion normally reserved only for fencing! She may be spectacularly unsuited to mix with aristocracy, but Ben has different ideas when he plans  to safeguard her business with a very  convenient proposal.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michelle Styles
      </h2>
      
      <p class="authorDescription body article">Michelle Styles writes warm, witty and intimate historical romance in a range of periods including Viking &#160;and early Victorian. Born and raised near San Francisco, California, &#160;she &#160;currently lives near Hadrian&#39;s Wall in the UK with her husband, menagerie of pets and occasionally one of her three university-aged children. An avid reader, she became hooked on historical romance after discovering &#160;Georgette Heyer, Anya Seton and Victoria Holt. &#160;&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d6304fea